module.exports = __webpack_public_path__ + "img/3_29.01776a1b.png";